import produce from "immer";
import {
  PORTFOLIO_COPY_STARTED, PORTFOLIO_COPY_QUEUED,
  PORTFOLIO_COPY_ITEM_STARTED, PORTFOLIO_COPY_ITEM_COMPLETED,
  PORTFOLIO_COPY_ITEM_FAILED, PORTFOLIO_COPY_ALL_COMPLETED,
  PORTFOLIO_COPY_ALL_FAILED, PORTFOLIO_COPY_JOB_DISMISS,
} from "../types";

const PROJECT_STATUS = { QUEUED: "QUEUED", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", FAILED: "FAILED" };

const initialJobState = {
  active: false, open: false, startedAt: null, terminatedAt: null,
  totalProjects: 0, completedCount: 0, failedCount: 0,
  etaSeconds: null, avgSecondsPerWeight: null, error: null, projects: [],
};

export const initialState = { jobs: {} };

function upsertProject(job, index, patch) {
  if (index == null) return;
  const idx = job.projects.findIndex((p) => p.index === index);
  if (idx === -1) {
    job.projects.push({ index, label: patch.label ?? "", status: PROJECT_STATUS.QUEUED, ...patch });
    return;
  }
  Object.assign(job.projects[idx], patch);
}

export default function portfolioCopyReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PORTFOLIO_COPY_STARTED:
      return produce(state, (draft) => {
        draft.jobs[payload.jobId] = { ...initialJobState, active: true, open: true,
          startedAt: payload.startedAt ?? 0, jobId: payload.jobId };
      });

    case PORTFOLIO_COPY_QUEUED:
      return produce(state, (draft) => {
        const job = draft.jobs[payload.jobId];
        if (!job) return;
        job.totalProjects = payload.total ?? 0;
        if (payload.etaSeconds != null) job.etaSeconds = payload.etaSeconds;
        if (payload.avgSecondsPerWeight != null) job.avgSecondsPerWeight = payload.avgSecondsPerWeight;
      });

    case PORTFOLIO_COPY_ITEM_STARTED:
      return produce(state, (draft) => {
        const job = draft.jobs[payload.jobId];
        if (!job) return;
        upsertProject(job, payload.index, { label: payload.label, status: PROJECT_STATUS.IN_PROGRESS });
      });

    case PORTFOLIO_COPY_ITEM_COMPLETED:
      return produce(state, (draft) => {
        const job = draft.jobs[payload.jobId];
        if (!job) return;
        upsertProject(job, payload.index, { status: PROJECT_STATUS.COMPLETED });
        job.completedCount = job.projects.filter((p) => p.status === PROJECT_STATUS.COMPLETED).length;
        job.failedCount = job.projects.filter((p) => p.status === PROJECT_STATUS.FAILED).length;
      });

    case PORTFOLIO_COPY_ITEM_FAILED:
      return produce(state, (draft) => {
        const job = draft.jobs[payload.jobId];
        if (!job) return;
        upsertProject(job, payload.index, { status: PROJECT_STATUS.FAILED, error: payload.error });
        job.completedCount = job.projects.filter((p) => p.status === PROJECT_STATUS.COMPLETED).length;
        job.failedCount = job.projects.filter((p) => p.status === PROJECT_STATUS.FAILED).length;
      });

    case PORTFOLIO_COPY_ALL_COMPLETED:
      return produce(state, (draft) => {
        const job = draft.jobs[payload?.jobId];
        if (!job) return;
        job.active = false; job.etaSeconds = 0;
        job.terminatedAt = payload?.terminatedAt ?? Date.now();
      });

    case PORTFOLIO_COPY_ALL_FAILED:
      return produce(state, (draft) => {
        const job = draft.jobs[payload?.jobId];
        if (!job) return;
        job.active = false; job.error = payload?.error || "Copy failed";
        job.terminatedAt = payload?.terminatedAt ?? Date.now();
      });

    case PORTFOLIO_COPY_JOB_DISMISS:
      return produce(state, (draft) => {
        if (payload?.jobId === "all") {
          Object.keys(draft.jobs).forEach((id) => { if (!draft.jobs[id].active) delete draft.jobs[id]; });
        } else if (payload?.jobId) { delete draft.jobs[payload.jobId]; }
      });

    default: return state;
  }
}
export { PROJECT_STATUS };
